var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutImage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 560.854,
    height: 616.942,
    viewBox: "0 0 560.854 616.942",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4987",
    "data-name": "Group 4987",
    transform: "translate(-1449.106 -667.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4965",
    "data-name": "Group 4965",
    transform: "translate(1449.106 667.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4891",
    "data-name": "Group 4891",
    transform: "translate(0 325.504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9447",
    "data-name": "Path 9447",
    d: "M1949.869,2584.646c-39.953,7.173-123,10.719-145-1.568-23.638-13.2-46.353-17.065-55.124-17.474-28.918,1.01-65.236-2.73-82.148-6.112-30.736-6.148-32.419-.975-40.873,9.016s-79.771,10.76-108.2,0-7.485-27.637-7.485-27.637-13.83-9.312-16.991-11.986c-2.851-2.413-17.219,4.866-38.734-15.112s15.9-26.171,65.847-32.317,415.389-30.267,415.389-30.267,56.862,59.937-9.99,71.461c-33.045,5.7-52.572,12.9-67.676,19.559,55.753,5.419,113.385-12.252,141.186,7.6C2028.755,2570.3,1989.823,2577.475,1949.869,2584.646Z",
    transform: "translate(-1449.106 -2299.739)",
    fill: "#d8e1f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4890",
    "data-name": "Group 4890",
    transform: "translate(17.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9448",
    "data-name": "Path 9448",
    d: "M1709.2,1887.717a70.725,70.725,0,0,0-30.492-1.54c-21.055,3.576-54.345,10.677-69.558,21.694-20.645,14.951-22.07,46.432-32.91,68.4s-23.846,68.11-47.692,85.687-14.3,30.372-9.96,39.161,162.042,18.934,207.232,26.752,136.627,8.224,169.352-7.6,53.934-18.766,77.78-27.554,26.014-63.716,10.839-103.264-49.86-79.1-84.545-85.687C1867.736,1897.782,1755.492,1900.371,1709.2,1887.717Z",
    transform: "translate(-1513 -1885.052)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4889",
    "data-name": "Group 4889",
    transform: "translate(1.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9449",
    "data-name": "Path 9449",
    d: "M1734.537,2017.68c1.537-18.442,6.147-29.969,26.126-33.042s69.158-16.905,83.758-25.358,40.727-19.979,56.1-23.821c10.821-2.705,20.88-15.316,25.886-22.541a73.925,73.925,0,0,0-23.939-9.525c-31.684-6.021-145-3.37-190.807-16.264a64.759,64.759,0,0,0-28.191-1.588c-20.936,3.486-55.509,10.663-71.1,21.953a40.059,40.059,0,0,0-3.612,2.954c-10,19.888-8.47,41.428-7.156,65.738,1.537,28.432,2.305,53.79,5.379,69.927s-8.453,39.958-23.053,43.8-28.432,7.684-45.337,9.221c-7.248.659-15.2-4.19-21.2-7.827a74.272,74.272,0,0,0,4.415,9.438c4.336,8.788,162.042,18.934,207.232,26.752,30.478,5.273,81.991,7.174,122.342,3-21.553-10.91-53.21-6.215-72.274-10.614-19.979-4.61-59.937-6.916-73-14.6s-7.684-16.137,4.611-30.737S1733,2036.122,1734.537,2017.68Z",
    transform: "translate(-1517.391 -1884.673)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9450",
    "data-name": "Path 9450",
    d: "M2666.132,2345.162s-6.147,15.368,12.295,29.969,39.958,4.61,57.632,16.137,23.053,8.452,46.874,9.221,26.895-13.063,27.663-18.443-36.884-5.379-51.484-17.674-13.063-12.295-25.358-30.737-47.643-10.758-59.937-11.526S2671.511,2339.783,2666.132,2345.162Z",
    transform: "translate(-2358.312 -2204.471)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9451",
    "data-name": "Path 9451",
    d: "M3166.456,2126.627a171.407,171.407,0,0,0-34.03-54.217c1.209,5.568,2.924,15.912,1.329,24.417-2.305,12.295-13.063,33.042-.769,41.495s34.579,16.137,38.422,20.748a6.2,6.2,0,0,0,3.494,2A148.963,148.963,0,0,0,3166.456,2126.627Z",
    transform: "translate(-2696.839 -2022.221)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9452",
    "data-name": "Path 9452",
    d: "M2369.685,2443.9s-7.684,13.063-11.526,23.053-5.379,19.979-9.99,24.589,19.211,12.295,30.738,13.063,9.221-7.684,16.905-16.906-7.684-16.137-9.221-27.663S2381.211,2423.149,2369.685,2443.9Z",
    transform: "translate(-2125.644 -2288.606)",
    fill: "#b2b2b2"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4964",
    "data-name": "Group 4964",
    transform: "translate(72.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4915",
    "data-name": "Group 4915",
    transform: "translate(0 311.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4900",
    "data-name": "Group 4900",
    transform: "translate(0.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9453",
    "data-name": "Path 9453",
    d: "M2069.957,1886.183c-6.916,43.284-43.541,37.395-76.322,31.5-28.439-5.108-58.162-15.206-65.537-17.791,1.773,32.719-2.954,131.283-4.847,130.837-2.04-.479-42.244,3.366-42.244,3.366s-2.139-13.941-6.707-40.587-7.05-84.81-5.769-119.585c.483-13.1,3.785-21.928,7.713-27.849a28.572,28.572,0,0,1,20.081-12.442,222.787,222.787,0,0,1,39.171-1.235c14.6.767,84.008,10.5,84.008,10.5C2081.482,1850.839,2071.751,1873.121,2069.957,1886.183Z",
    transform: "translate(-1828.902 -1832.058)",
    fill: "#121d3f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4899",
    "data-name": "Group 4899",
    transform: "translate(0 185.827)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9454",
    "data-name": "Path 9454",
    d: "M1816.347,2559.728a85.71,85.71,0,0,0-.63,14.654,15.081,15.081,0,0,1-.068,3.407c-.879,6.031-5.89,5.609-5.89,5.609s-14.224,2.109-26.51,3.377-47.195,6.049-53.412,4.143c-3.6-1.106-7.821-2.867-8.435-6.974-.444-2.972.5-7.364,5.427-13.432,11.539-14.205,28.806-5.687,41.808-13.792.454-.284,5.189-8.694,2.756-20.314-1.239-5.912-.63-7.188,1.693-6.49,2.466.741,6.847,3.691,12.983,5.689,3.443,1.123,9.043.417,14.63-1.119,6.45-1.771,12.888-4.646,15.979-7.093C1820.447,2524.411,1817.58,2551.677,1816.347,2559.728Z",
    transform: "translate(-1721.281 -2527.166)",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4898",
    "data-name": "Group 4898",
    transform: "translate(0 2.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9455",
    "data-name": "Path 9455",
    d: "M1942.613,2542.023c-3.1,1.163-12.683,4.508-17.675,3.443-6.009-1.282-9.938-8.013-9.938-8.013,2.466.741,6.847,3.691,12.983,5.69C1931.426,2544.265,1937.026,2543.559,1942.613,2542.023Z",
    transform: "translate(-1863.194 -2537.453)",
    fill: "#cc5050"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4893",
    "data-name": "Group 4893",
    transform: "translate(43.767 27.456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4892",
    "data-name": "Group 4892"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9456",
    "data-name": "Path 9456",
    d: "M1890.434,2650.4a.54.54,0,0,1-.541-.541,10.152,10.152,0,0,0-4.691-8.693.541.541,0,0,1,.533-.942,11.236,11.236,0,0,1,5.24,9.635A.541.541,0,0,1,1890.434,2650.4Z",
    transform: "translate(-1884.928 -2640.156)",
    fill: "#eaebf4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4895",
    "data-name": "Group 4895",
    transform: "translate(37.328 29.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4894",
    "data-name": "Group 4894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9457",
    "data-name": "Path 9457",
    d: "M1866.35,2657.211a.541.541,0,0,1-.541-.541,10.291,10.291,0,0,0-4.69-8.692.541.541,0,1,1,.532-.942,11.238,11.238,0,0,1,5.24,9.635A.541.541,0,0,1,1866.35,2657.211Z",
    transform: "translate(-1860.844 -2646.966)",
    fill: "#eaebf4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4897",
    "data-name": "Group 4897",
    transform: "translate(30.011 29.552)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4896",
    "data-name": "Group 4896"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9458",
    "data-name": "Path 9458",
    d: "M1838.979,2658.24a.541.541,0,0,1-.541-.541,10.151,10.151,0,0,0-4.691-8.693.541.541,0,0,1,.533-.942,11.236,11.236,0,0,1,5.24,9.635A.541.541,0,0,1,1838.979,2658.24Z",
    transform: "translate(-1833.474 -2647.995)",
    fill: "#eaebf4"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9459",
    "data-name": "Path 9459",
    d: "M1815.582,2716.535c.193,2.372.761,10.367-.178,12.709-1.109,2.761-21.815,4.226-22.925,4.41s.872-3.863-5.788-3.72-3.312,3.655-6.1,4.841-40.494,4.9-49.365,2.674-10.53-13.358-9.891-14.761c.615,4.109,4.83,5.869,8.436,6.974,6.215,1.906,41.124-2.878,53.41-4.144s26.51-3.377,26.51-3.377S1814.7,2722.563,1815.582,2716.535Z",
    transform: "translate(-1721.214 -2668.66)",
    fill: "#212851"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4914",
    "data-name": "Group 4914",
    transform: "translate(0 0.195)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9460",
    "data-name": "Path 9460",
    d: "M2183.358,1892.1c-12.038,17.674-46.359,34.831-75.554,43.028s-42.317,10.72-50.257,12.257c-.331.695-13.289,36.058-23.868,55.646s-43.669,62.134-43.669,62.134l-29.61-17.222s40.028-129.891,47.88-146c7.769-15.934,31.441-24.943,31.944-25.132.005,0,.008,0,.013-.005,19.4-9.616,50.826-23.83,65.262-31.321,20.232-10.5,67.358-23.05,82.981,1.537C2188.48,1847.02,2195.4,1874.425,2183.358,1892.1Z",
    transform: "translate(-1895.769 -1832.786)",
    fill: "#212851"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4913",
    "data-name": "Group 4913",
    transform: "translate(0 212.409)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9461",
    "data-name": "Path 9461",
    d: "M1814.307,2678.7a15.113,15.113,0,0,1-.387,3.386c-1.441,5.922-6.39,5.033-6.39,5.033s-14.359.768-26.71.879-47.554,1.6-53.563-.879c-3.486-1.439-7.518-3.586-7.745-7.734-.162-3,1.187-7.285,6.663-12.864,12.818-13.062,27.883-4.327,41.586-11.177s11.082-8.924,14.1-17.908a50.564,50.564,0,0,0,2.371-9.362.856.856,0,0,1,1.014-.733l.03,0a.858.858,0,0,1,.481.294,21.085,21.085,0,0,0,5.56,4.508c5.887,3.486,16.212-.36,16.212-.36a17.743,17.743,0,0,1,5.92-.687,9.841,9.841,0,0,1,1.041.133.035.035,0,0,1,.016,0,.379.379,0,0,1,.057.011,7.326,7.326,0,0,1,6.079,6.723,25.11,25.11,0,0,0-4.522,13.206C1815.488,2661.653,1814.429,2669.084,1814.307,2678.7Z",
    transform: "translate(-1719.27 -2627.327)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4912",
    "data-name": "Group 4912",
    transform: "translate(0 0.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4904",
    "data-name": "Group 4904",
    transform: "translate(67.821 38.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4901",
    "data-name": "Group 4901",
    transform: "translate(0 12.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9462",
    "data-name": "Path 9462",
    d: "M1972.873,2826.624a.55.55,0,0,1-.161-.025.541.541,0,0,1-.356-.677,14.9,14.9,0,0,1,4.684-6.846.541.541,0,0,1,.639.873,14,14,0,0,0-4.29,6.295A.541.541,0,0,1,1972.873,2826.624Z",
    transform: "translate(-1972.332 -2818.971)",
    fill: "#d35f5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4902",
    "data-name": "Group 4902",
    transform: "translate(6.75 4.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9463",
    "data-name": "Path 9463",
    d: "M1998.123,2797.524a.541.541,0,0,1-.321-.976c.063-.074.206-.262.334-.431.9-1.193,3.023-3.987,5.328-4.839a.541.541,0,1,1,.375,1.014c-2.009.743-3.994,3.36-4.842,4.478-.453.6-.534.7-.787.746A.571.571,0,0,1,1998.123,2797.524Z",
    transform: "translate(-1997.583 -2791.244)",
    fill: "#d35f5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4903",
    "data-name": "Group 4903",
    transform: "translate(15.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9464",
    "data-name": "Path 9464",
    d: "M2029.6,2776.851a.541.541,0,0,1-.356-.948c.162-.141,4-3.455,6.729-3.134a.541.541,0,1,1-.128,1.074c-1.872-.225-4.886,2-5.89,2.875A.539.539,0,0,1,2029.6,2776.851Z",
    transform: "translate(-2029.054 -2772.747)",
    fill: "#d35f5f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4911",
    "data-name": "Group 4911",
    transform: "translate(36.811 25.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4906",
    "data-name": "Group 4906",
    transform: "translate(14.324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4905",
    "data-name": "Group 4905"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9465",
    "data-name": "Path 9465",
    d: "M1917.067,2730.681a.541.541,0,0,1-.53-.439,10.152,10.152,0,0,0-6.252-7.647.541.541,0,0,1,.345-1.026,11.238,11.238,0,0,1,6.969,8.469.541.541,0,0,1-.429.633A.53.53,0,0,1,1917.067,2730.681Z",
    transform: "translate(-1909.917 -2721.541)",
    fill: "#eaebf4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4908",
    "data-name": "Group 4908",
    transform: "translate(8.347 3.007)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4907",
    "data-name": "Group 4907"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9466",
    "data-name": "Path 9466",
    d: "M1894.711,2741.93a.541.541,0,0,1-.531-.439,10.15,10.15,0,0,0-6.252-7.647.541.541,0,0,1,.345-1.025,11.235,11.235,0,0,1,6.969,8.469.54.54,0,0,1-.429.633A.524.524,0,0,1,1894.711,2741.93Z",
    transform: "translate(-1887.561 -2732.79)",
    fill: "#eaebf4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910",
    transform: "translate(0 4.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4909",
    "data-name": "Group 4909"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9467",
    "data-name": "Path 9467",
    d: "M1863.487,2749a.541.541,0,0,1-.531-.439,10.149,10.149,0,0,0-6.252-7.647.541.541,0,0,1,.345-1.025,11.235,11.235,0,0,1,6.97,8.468.541.541,0,0,1-.532.643Z",
    transform: "translate(-1856.336 -2739.861)",
    fill: "#eaebf4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9468",
    "data-name": "Path 9468",
    d: "M1813.291,2824.759c-.03,2.379-.214,10.393-1.369,12.637-1.363,2.645-22.116,2.164-23.238,2.242s1.23-3.765-5.414-4.246-3.64,3.329-6.526,4.249-40.775,1.084-49.4-1.963-9.233-14.287-8.464-15.623c.227,4.148,4.259,6.3,7.745,7.734,6.009,2.479,41.213.987,53.563.879s26.71-.879,26.71-.879S1811.849,2830.679,1813.291,2824.759Z",
    transform: "translate(-1718.64 -2770.011)",
    fill: "#212851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9469",
    "data-name": "Path 9469",
    d: "M1993.639,2631.14l.79.105c-3.332-.214-11.42,4.962-19.2,4.673-7.932-.295-9.795-8.537-9.795-8.537a.219.219,0,0,1,.03,0,.854.854,0,0,1,.481.294,21.087,21.087,0,0,0,5.56,4.508c5.887,3.486,16.212-.36,16.212-.36A17.736,17.736,0,0,1,1993.639,2631.14Z",
    transform: "translate(-1899.458 -2627.381)",
    fill: "#d35f5f"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4963",
    "data-name": "Group 4963",
    transform: "translate(67.377)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4942",
    "data-name": "Group 4942",
    transform: "translate(0 101.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4920",
    "data-name": "Group 4920",
    transform: "translate(0 28.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4917",
    "data-name": "Group 4917",
    transform: "translate(0 108.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9470",
    "data-name": "Path 9470",
    d: "M2078.751,1582.162a192.207,192.207,0,0,1-21.157,39.4c-13.481,18.839-34.491,45.081-42.66,44.253s-4.194-14.758-1.446-25.884,13.717-41.591,20.04-53.317c8.628-16,10.734-28.446,22.31-28.7S2080.162,1562.952,2078.751,1582.162Z",
    transform: "translate(-1999.534 -1557.905)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4916",
    "data-name": "Group 4916",
    transform: "translate(0.571 77.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9471",
    "data-name": "Path 9471",
    d: "M1986.1,1851.436s-6.1,20.409-7.764,23.867-5.25,13.574-5.506,17.416,1.921,20.49,5.635,30.606c.64,2.305,2.817,3.074,3.714,2.049,0,0,3.074,3.458,5.122-.256,0,0,3.714,2.817,4.994-1.025,0,0,4.354,1.921,4.61-1.281s-2.561-23.178-2.817-26.38.353-6.019,1.409-6.019c1.921,0,2.305,7.427,2.433,12.166s3.97,3.073,4.61-1.665a52.953,52.953,0,0,0-1.409-20.233,18.1,18.1,0,0,1,2.9-15.351C2005.7,1863.41,1994.807,1834.276,1986.1,1851.436Z",
    transform: "translate(-1972.809 -1846.047)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9472",
    "data-name": "Path 9472",
    d: "M1996.131,2095.668c-.448-1.405-.865-2.819-1.288-4.231s-.813-2.834-1.208-4.255-.835-2.832-1.116-4.282a33.252,33.252,0,0,1-.615-4.394.039.039,0,0,1,.075-.015c.5,1.4.905,2.814,1.288,4.235s.641,2.871.964,4.308.648,2.872.983,4.307l.99,4.308a.038.038,0,0,1-.074.02Z",
    transform: "translate(-1986.8 -2016.331)",
    fill: "#e57e73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9473",
    "data-name": "Path 9473",
    d: "M2015.993,2092.136c-.435-1.484-.837-2.976-1.246-4.467s-.782-2.991-1.158-4.491-.8-2.99-1.054-4.519c-.131-.763-.249-1.529-.338-2.3s-.157-1.546-.175-2.325a.039.039,0,0,1,.038-.04.038.038,0,0,1,.038.028c.456,1.489.831,2.982,1.19,4.483s.6,3.026.9,4.539.613,3.026.932,4.537l.946,4.537a.038.038,0,0,1-.03.045A.039.039,0,0,1,2015.993,2092.136Z",
    transform: "translate(-2001.539 -2013.056)",
    fill: "#e57e73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9474",
    "data-name": "Path 9474",
    d: "M2035.559,2089.24c-.458-1.443-.87-2.9-1.28-4.357-.394-1.462-.777-2.927-1.13-4.4a45.465,45.465,0,0,1-.946-4.451c-.1-.754-.194-1.508-.238-2.269a19.424,19.424,0,0,1-.035-2.286.038.038,0,0,1,.04-.037.039.039,0,0,1,.036.03c.349,1.484.651,2.955.953,4.431.15.738.284,1.478.406,2.222s.247,1.488.384,2.23c.276,1.484.584,2.962.9,4.439s.642,2.954.981,4.428a.038.038,0,0,1-.029.046A.039.039,0,0,1,2035.559,2089.24Z",
    transform: "translate(-2016.111 -2011.183)",
    fill: "#e57e73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9475",
    "data-name": "Path 9475",
    d: "M2002.8,1951.162c-.151,4.41-.847,8.236-2.4,9.371a6.21,6.21,0,0,1-1.1.655c-3.082,1.389-4.763-1.742-5.087-3.9-.335-2.251.169,2.89,1.622,9.978.1.476.2.957.3,1.443,1.683,7.811-.333,16.346-14.41,13.7s-10.845-33.642-10.482-40.56c.179-3.44,1.975-8.627,3.739-12.973,1.775-4.379,3.515-7.9,3.515-7.9s20.006-.727,23.208,6.975a6.436,6.436,0,0,0-.645,6.86C2002.127,1937.294,2003.02,1944.827,2002.8,1951.162Z",
    transform: "translate(-1970.673 -1823.903)",
    fill: "#ffc675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9476",
    "data-name": "Path 9476",
    d: "M2014.616,1951.162a30.012,30.012,0,0,0-13.194-21.875c-4.968-3.245-14.622-.409-14.622-.409,1.777-4.381,3.516-7.9,3.516-7.9s20.006-.728,23.208,6.974a6.438,6.438,0,0,0-.644,6.861C2013.943,1937.294,2014.835,1944.828,2014.616,1951.162Z",
    transform: "translate(-1982.489 -1823.903)",
    fill: "#f2b255",
    opacity: 0.58
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4919",
    "data-name": "Group 4919",
    transform: "translate(7.075)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9477",
    "data-name": "Path 9477",
    d: "M2170.489,1163.411s-10.012,9.576-16.814,35.526-19.968,79.08-19.726,89.549,15.582,22.622,28.913,11.287,20.95-41.217,28.286-59.237c9.71-23.854,12.367-56.389,5.189-67.92S2173.275,1161.069,2170.489,1163.411Z",
    transform: "translate(-2097.373 -1159.939)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4918",
    "data-name": "Group 4918"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9478",
    "data-name": "Path 9478",
    d: "M2102.835,1196.749c-3.5,28.089-23.1,74.53-23.486,75.422-2.5,5.755-8.156,16.358-13.989,27.186-2.777,5.157-5.592,10.365-8.126,15.12-7.854,14.744-34.615,53.044-36.134,51.392s-23.96-7.161-23.96-7.161.841-3.737,7.369-25,26.123-61.857,28.046-67.468,8.894-46.248,16.466-71.593c8.589-28.752,21.1-39.528,21.1-39.528,18.5-5.646,32.126,6.836,33.211,32.243A57.346,57.346,0,0,1,2102.835,1196.749Z",
    transform: "translate(-1997.139 -1153.78)",
    fill: "#548ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9479",
    "data-name": "Path 9479",
    d: "M2270.483,1249.579c-3.5,28.089-23.1,74.53-23.487,75.422-2.5,5.755-8.156,16.358-13.989,27.186-1.528-20.093-5.235-75.116-6.593-88.829-1.893-19.127,2.723-37.47,2.723-37.47S2255.479,1229.443,2270.483,1249.579Z",
    transform: "translate(-2164.787 -1206.61)",
    fill: "#3c71c6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4923",
    "data-name": "Group 4923",
    transform: "translate(70.05)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9480",
    "data-name": "Path 9480",
    d: "M2302.458,1089.449s34.891-7.918,59.084,5.425,17.1,57.208,11.768,82.775-3.629,47.575-4.027,70.03-5.372,44.409-45.861,49.371-50.374-20.29-54.466-35.147-10.774-60.7-17.312-83.418-15.418-64.29,6.769-76.025S2290.306,1091.845,2302.458,1089.449Z",
    transform: "translate(-2241.159 -1076.163)",
    fill: "#f7bead"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4922",
    "data-name": "Group 4922"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9481",
    "data-name": "Path 9481",
    d: "M2387.9,1272.14c-95.628,27.592-133.058-5.844-138.858-10.173-.379-.284,5.254-12.5,5.465-16.975,1.066-22.724-2.834-37.275-4.148-44.139-3.05-16.391-9.735-51.816-13.5-64.162s-6.8-41.456-.612-52.719,18.968-16.98,23.97-19.384a52.5,52.5,0,0,1,12.107-3.367c.549-2.393.9-4.154.9-4.154s.844,2.766,9.127,2.888c3.234-.338,6.512-.668,9.817-1.146,9.851-3.172,13.959-12.667,13.959-12.667,1.25,2.664,7.345,5.262,12.167,6.955,3.394,1.193,6.158,1.934,6.158,1.934.578,0,1.154,0,1.725.013a51.91,51.91,0,0,1,7.018.571c21.291,3.3,29.963,13.886,29.963,13.886,16.5,21.418,7.42,63.729,5.284,78.248-1.677,11.4-2.526,23.74-1.669,34.29a72.847,72.847,0,0,0,1.112,8.213c1.585,7.964,4.927,24.054,7.721,35.707a115.354,115.354,0,0,0,3.486,12.551c2.518,6.19,9.254,28.471,10.07,31.369A1.836,1.836,0,0,1,2387.9,1272.14Z",
    transform: "translate(-2232.703 -1046.143)",
    fill: "#548ae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9482",
    "data-name": "Path 9482",
    d: "M2403.814,1111.25c-7.632,11.379-8.913,13.943-6.75,29.568,1.436,10.371,6.75,30.769,6.75,30.769s-8.808,5.408-18.475,5.444c-.054.23-2.785,11.474-23.13,13.759-20.552,2.309-16.785-8.129-16.785-8.129l32.889-7.523c-6.831-11.85,20.082-98.968,20.082-98.968a16.474,16.474,0,0,1,2.285-4.011c3.394,1.193,6.158,1.933,6.158,1.933.579,0,1.155,0,1.725.014.246,2.269.4,6.88-1.966,9.113C2403.393,1086.252,2411.446,1099.873,2403.814,1111.25Z",
    transform: "translate(-2315.092 -1065.205)",
    fill: "#3c71c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4921",
    "data-name": "Group 4921",
    transform: "translate(50.166 44.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9483",
    "data-name": "Path 9483",
    d: "M2513.089,1347.735c-.449.089-41.01,8.032-46.746,10.679-5.768,2.661-7.332-.845-11.177,1.077s-20.931,10.043-21.891,14.207-12.92-6.631-12.92-6.631l10.733-27.627,5.63-2.742-4.027-1.1s-.687-8.345.479-8.835,16.707,2.344,22.6-1.019,24.638-12.74,32.57-19.593c7.78-6.718,1.677-18.37,1.439-18.819-.057-.1-.108-.189-.162-.281l-.116-.2c-7.218-12.32-14.73-25.912-19.06-35.956-10.206-23.667-8.1-38.541-8.1-38.541s25.193,2.012,47.627,7.1c1.655,19.527-2.65,40.653-4.037,50.075-1.687,11.469-2.537,23.9-1.649,34.493.035.43.073.857.116,1.282.051.535.108,1.063.173,1.585.021.205.048.411.075.614.022.184.046.365.071.546.046.344.092.684.143,1.02.046.306.094.611.143.911.035.224.073.446.114.668l.056.33c.065.357.13.706.2,1.055C2506.953,1319.992,2510.295,1336.083,2513.089,1347.735Z",
    transform: "translate(-2420.354 -1212.352)",
    fill: "#3c71c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9484",
    "data-name": "Path 9484",
    d: "M2736.132,1583.661c-.36-.571-.747-1.19-1.163-1.852l.706-.552c.065.354.13.706.2,1.055C2735.964,1582.763,2736.051,1583.212,2736.132,1583.661Z",
    transform: "translate(-2650.861 -1482.635)",
    fill: "#3c71c6"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4941",
    "data-name": "Group 4941",
    transform: "translate(103.854 13.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937",
    transform: "translate(0 107.748)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9485",
    "data-name": "Path 9485",
    d: "M2624.473,1530.546s-15.532,7.745-44.825,17.455-38.116,11.113-52.556,14.691c-11.4,2.825-14.545-9.478-.9-17.58s25.005-16.484,43.758-26.308,34.9-20.43,43.984-19.9C2626.78,1499.658,2635.26,1522.641,2624.473,1530.546Z",
    transform: "translate(-2474.941 -1498.886)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4936",
    "data-name": "Group 4936",
    transform: "translate(2.289 16.45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9486",
    "data-name": "Path 9486",
    d: "M2440.757,1659.551c-1.057,10.411-4.735,11.628-4.735,11.628a2.8,2.8,0,0,0-.37-4.9,7.238,7.238,0,0,0-1.409-.463,9.036,9.036,0,0,0-1.985.268c-2.866.276-7.962,2.512-10.687,1.46a1.688,1.688,0,0,1-.719-2.6,9.692,9.692,0,0,1,4.089-2.8c5.152-2.139,9.019-3.085,12.069-3.156A23.071,23.071,0,0,1,2440.757,1659.551Z",
    transform: "translate(-2406.389 -1632.641)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "cap",
    transform: "translate(0.67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4935",
    "data-name": "Group 4935"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4924",
    "data-name": "Group 4924",
    transform: "translate(29.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9487",
    "data-name": "Path 9487",
    d: "M2485.344,1572.812a8.793,8.793,0,0,1-2.094-.539l-.341-1.309c.659.263,3.821,1.119,6.166.015,1.344-.633,3.818-2.507,3.559-5.072a5,5,0,0,0-3.75-4.051c-2.733-.666-6.661,1.574-8.5,6.464l-1.234-.464c1.879-4.991,6.29-8.189,10.047-7.281a6.378,6.378,0,0,1,4.751,5.2c.333,3.295-2.552,5.573-4.31,6.4A7.677,7.677,0,0,1,2485.344,1572.812Z",
    transform: "translate(-2479.148 -1560.419)",
    fill: "#3b4a75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4925",
    "data-name": "Group 4925",
    transform: "translate(0 7.871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9488",
    "data-name": "Path 9488",
    d: "M2404.106,1678.708c0-.006,1.915-50.135,1.915-50.135l-33.383.479.9,13.463,2.452,36.592a.226.226,0,0,0,0,.046c.022,1.517,6.333,2.656,14.1,2.544,1.812-.026,3.544-.117,5.136-.264.359-.031.709-.068,1.051-.1a37.618,37.618,0,0,0,3.959-.627c.378-.082.731-.169,1.062-.258,1.774-.485,2.821-1.075,2.812-1.695A.273.273,0,0,0,2404.106,1678.708Z",
    transform: "translate(-2371.993 -1618.224)",
    fill: "#eb7373"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9489",
    "data-name": "Path 9489",
    d: "M2463.465,1634.067l-.024.731-1.52,46.156-.007.251-.053,1.61-.055,1.655c-.331.089-.684.176-1.062.258a37.613,37.613,0,0,1-3.959.627l-.075-2.466-.075-2.471,0-.089-1.381-44.421-.024-.746Z",
    transform: "translate(-2432.5 -1622.25)",
    fill: "#3b4a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9490",
    "data-name": "Path 9490",
    d: "M2459.518,1634.123l-.024.731-1.52,46.156-.06,1.861-.062,1.9a40.774,40.774,0,0,1-5.01.731l-.079-2.555-.079-2.561-1.381-44.42-.024-.746Z",
    transform: "translate(-2429.609 -1622.29)",
    fill: "#e5d7d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9491",
    "data-name": "Path 9491",
    d: "M2404.576,1595.469a.745.745,0,0,0,.1-.364c-.006-.448-.471-.869-1.294-1.248a.892.892,0,0,0,.307-.626l.912-3.37-34.378.493,1.008,3.342a.892.892,0,0,0,.325.616c-.812.4-1.264.836-1.258,1.285a.75.75,0,0,0,.109.361l.9,2.981a.971.971,0,0,0,.42.7c-.559.334-.863.686-.857,1.049.025,1.8,7.52,3.151,16.738,3.019s16.671-1.7,16.645-3.5c-.005-.363-.319-.707-.887-1.024a.971.971,0,0,0,.4-.712Z",
    transform: "translate(-2370.222 -1589.862)",
    fill: "#b2b2b2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9492",
    "data-name": "Path 9492",
    d: "M2404.6,1581.318c.006.419-.382.823-1.094,1.2-2.44,1.3-8.7,2.293-16.049,2.4s-13.632-.7-16.108-1.938c-.723-.359-1.122-.752-1.128-1.171-.027-1.854,7.649-3.466,17.14-3.6S2404.573,1579.464,2404.6,1581.318Z",
    transform: "translate(-2370.221 -1573.447)",
    fill: "#3b4a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9493",
    "data-name": "Path 9493",
    d: "M2405.489,1703.46c.012.77-7.044,3.334-14.8,3.444a39.973,39.973,0,0,1-5.183-.273c-5.484-.629-9.706-2.177-9.711-2.763l-2.119-24.227a.437.437,0,0,1,.619-.435,22.26,22.26,0,0,0,4.875,1.3c1.373.246,2.951.461,4.676.617a63.09,63.09,0,0,0,6.477.246c9.075-.125,16.432-2.263,16.64-3.157l-1.478,25.229A.038.038,0,0,1,2405.489,1703.46Z",
    transform: "translate(-2372.747 -1646.72)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9494",
    "data-name": "Path 9494",
    d: "M2409.132,1586.558a.311.311,0,0,1,0,.6,77.813,77.813,0,0,1-15.011,1.358c-2.471.036-4.825,0-6.951-.09-1.706-.073-3.266-.182-4.627-.324-.52-.053-1.012-.112-1.469-.174-.748-.1-1.171-.135-1.533-.192a.232.232,0,0,1-.034-.45,51.945,51.945,0,0,1,14.565-2.165A64.06,64.06,0,0,1,2409.132,1586.558Z",
    transform: "translate(-2376.906 -1578.515)",
    fill: "#212851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9495",
    "data-name": "Path 9495",
    d: "M2385.483,1709.283c-5.484-.629-9.706-2.177-9.71-2.763l-2.126-24.307c-.026-.3.386-.472.658-.341a20.9,20.9,0,0,0,4.843,1.282c1.373.246,2.951.462,4.676.617Q2384.653,1696.528,2385.483,1709.283Z",
    transform: "translate(-2372.729 -1649.371)",
    fill: "#f2edeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4933",
    "data-name": "Group 4933",
    transform: "translate(2.781 33.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4926",
    "data-name": "Group 4926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9496",
    "data-name": "Path 9496",
    d: "M2382.54,1710.2a.66.66,0,0,1-.573-.615l-1.341-22.308a.659.659,0,1,1,1.317-.079l1.341,22.308a.661.661,0,0,1-.744.693Z",
    transform: "translate(-2380.625 -1686.58)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4927",
    "data-name": "Group 4927",
    transform: "translate(3.931 1.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9497",
    "data-name": "Path 9497",
    d: "M2396.557,1713.86a.66.66,0,0,1-.574-.635l-.654-22.215a.66.66,0,0,1,1.319-.039l.654,22.215a.66.66,0,0,1-.64.679A.729.729,0,0,1,2396.557,1713.86Z",
    transform: "translate(-2395.329 -1690.332)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4928",
    "data-name": "Group 4928",
    transform: "translate(7.962 1.949)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9498",
    "data-name": "Path 9498",
    d: "M2411.292,1716.937a.66.66,0,0,1-.574-.645l-.312-21.753a.659.659,0,0,1,1.319-.019l.312,21.753a.659.659,0,0,1-.65.669A.676.676,0,0,1,2411.292,1716.937Z",
    transform: "translate(-2410.406 -1693.87)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4929",
    "data-name": "Group 4929",
    transform: "translate(12.488 2.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9499",
    "data-name": "Path 9499",
    d: "M2428.219,1718.56a.661.661,0,0,1-.574-.645l-.308-21.53a.659.659,0,0,1,1.319-.018l.309,21.53a.659.659,0,0,1-.65.669A.673.673,0,0,1,2428.219,1718.56Z",
    transform: "translate(-2427.337 -1695.716)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4930",
    "data-name": "Group 4930",
    transform: "translate(17.563 2.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9500",
    "data-name": "Path 9500",
    d: "M2447.206,1718.286a.66.66,0,0,1-.574-.645l-.309-21.53a.659.659,0,1,1,1.319-.018l.309,21.53a.659.659,0,0,1-.65.669A.713.713,0,0,1,2447.206,1718.286Z",
    transform: "translate(-2446.323 -1695.442)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4931",
    "data-name": "Group 4931",
    transform: "translate(22.513 1.74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9501",
    "data-name": "Path 9501",
    d: "M2465.72,1715.933a.659.659,0,0,1-.574-.645l-.309-21.53a.659.659,0,1,1,1.319-.019l.309,21.53a.659.659,0,0,1-.65.668A.6.6,0,0,1,2465.72,1715.933Z",
    transform: "translate(-2464.838 -1693.09)",
    fill: "#ccc2ca"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4932",
    "data-name": "Group 4932",
    transform: "translate(27.103 0.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9502",
    "data-name": "Path 9502",
    d: "M2482.58,1711.09a.659.659,0,0,1-.574-.665l.365-21.529a.66.66,0,0,1,1.319.022l-.366,21.529a.66.66,0,0,1-.671.648C2482.629,1711.095,2482.6,1711.093,2482.58,1711.09Z",
    transform: "translate(-2482.006 -1688.248)",
    fill: "#ccc2ca"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4934",
    "data-name": "Group 4934",
    transform: "translate(13.445 13.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9503",
    "data-name": "Path 9503",
    d: "M2421.087,1613.363a.66.66,0,0,1,.142-1.311c11.062.962,18-1.326,18.067-1.349a.66.66,0,0,1,.422,1.25c-.292.1-7.269,2.4-18.6,1.414Z",
    transform: "translate(-2420.512 -1610.668)",
    fill: "#ccc2ca"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_9504",
    "data-name": "Path 9504",
    d: "M2433.262,1669.906s-1.493,7.845-11.953,10.955-15.439,9.405-22.381,13.4a28.13,28.13,0,0,1-19.208,2.815c-4.743-1.282-15.049-6.593-10.566-9.859,0,0-3.44-4.427.308-5.614,0,0-1.287-4.038,1.971-4.965a5.485,5.485,0,0,1,3.1.335,36.9,36.9,0,0,0,11.526.83c2.763-.257,7.274-2.466,11.287-5.095,0,0,3.678-1.217,4.735-11.628,4.118.8,10.62,2.163,17.007,2.077C2426.6,1663.057,2433.25,1662.264,2433.262,1669.906Z",
    transform: "translate(-2367.713 -1634.17)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9505",
    "data-name": "Path 9505",
    d: "M2374.247,1737.712c1.767.376,3.54.73,5.317,1.047s3.557.619,5.343.857a48.7,48.7,0,0,0,5.362.461,46.267,46.267,0,0,0,5.353-.144l.022.074a9.743,9.743,0,0,1-2.653.739,12.185,12.185,0,0,1-2.752.107,53.187,53.187,0,0,1-5.415-.691q-2.681-.464-5.329-1.065c-1.764-.4-3.522-.829-5.267-1.309Z",
    transform: "translate(-2372.486 -1690.315)",
    fill: "#e57e73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9506",
    "data-name": "Path 9506",
    d: "M2373.075,1758.717q2.529,1.062,5.125,1.945a50.055,50.055,0,0,0,5.234,1.553,22.017,22.017,0,0,0,2.664.458c.45.048.9.1,1.351.13s.9.079,1.352.115a40.381,40.381,0,0,0,5.444.086l.016.075a13.923,13.923,0,0,1-2.725.513,22.063,22.063,0,0,1-2.774.093,22.649,22.649,0,0,1-2.762-.257,26.124,26.124,0,0,1-2.716-.616,50.667,50.667,0,0,1-5.217-1.79q-2.551-1.035-5.023-2.235Z",
    transform: "translate(-2371.618 -1705.705)",
    fill: "#e57e73"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9507",
    "data-name": "Path 9507",
    d: "M2419.218,1681.382s-6.375.572-13.163,6.079-19.047,14.114-34.191,10.232-15.656-20.583-7.313-22.512,21.289,1.573,26.681-4.441c3.455-3.855,4.2-6.667,4.41-8.239.115-.881.168-1.42.168-1.42l19.683,1.721Z",
    transform: "translate(-2359.152 -1617.72)",
    fill: "#ffc675"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4940",
    "data-name": "Group 4940",
    transform: "translate(50.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9508",
    "data-name": "Path 9508",
    d: "M2616.265,1110.78s12.88,12.26,34.181,54.079,35.65,65.891,21.4,76.495-39.972-23.895-53.02-39.948-39.085-57.664-37.056-76.281S2599.553,1097.739,2616.265,1110.78Z",
    transform: "translate(-2572.827 -1102.232)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4939",
    "data-name": "Group 4939"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4938",
    "data-name": "Group 4938"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9509",
    "data-name": "Path 9509",
    d: "M2650.219,1235.7c-17.145,16.3-51.6,21.518-65.381,25.236s-27.386,8.089-27.386,8.089-4.987-20.869-8.832-22.634c0,0,48.068-27.822,51.838-29.777s-.917-6.85-.917-6.85-26.458-40.4-36.345-60.161-13.191-51.676,12.586-53.761c5.706.224,13.151,4.013,21.915,10.833a319.432,319.432,0,0,1,46.881,73.472l.008.016C2645.089,1181.036,2667.172,1219.585,2650.219,1235.7Z",
    transform: "translate(-2548.62 -1095.841)",
    fill: "#548ae2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9510",
    "data-name": "Path 9510",
    d: "M2673.548,1280.941s18.451-13.634,30.63-16.52l3.878,6.729s-26.854,15.949-28.773,16.264C2678.57,1287.531,2673.548,1280.941,2673.548,1280.941Z",
    transform: "translate(-2640.15 -1219.354)",
    fill: "#3c71c6",
    opacity: 0.69
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4962",
    "data-name": "Group 4962",
    transform: "translate(77.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4943",
    "data-name": "Group 4943",
    transform: "translate(31.362 77.881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M2404.145,961.831a12.855,12.855,0,0,1,3.8,7.206c.8,4.609,2.969,15.012,7.235,21.484,5.607,8.507-6.993,22.7-17.715,23.215-11.619.554-15.8-3.2-17.752-13.266s-2.324-12.05-3.426-20.169c-1.758-12.942,6.4-19.94,13.844-21.4C2396.754,957.6,2401.153,959.02,2404.145,961.831Z",
    transform: "translate(-2376.042 -958.414)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M2390.129,958.9c6.626-1.3,11.024.12,14.016,2.931a12.857,12.857,0,0,1,3.8,7.206c.16.925.376,2.086.653,3.4-6.985,13.292-18.056,23.122-29,27.448-1.85-9.551-2.232-11.626-3.312-19.583C2374.527,967.36,2382.68,960.361,2390.129,958.9Z",
    transform: "translate(-2376.042 -958.414)",
    fill: "#e57e73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4944",
    "data-name": "Group 4944",
    transform: "translate(15.304 97.944)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M2360.91,1199.112a13.169,13.169,0,0,1-1.944,6.641c-8.862,14.614-40.571,11.9-34.357,4,4.2-5.345,10.814-29.876-3.151-48.627-10.024-13.456-4.034-33.741.146-44.12,1.642-4.081,3-6.628,3-6.628l11.234,2.6,16.447,3.8s1.8,12.112,3.753,27.416C2358.484,1163.316,2361.173,1187.424,2360.91,1199.112Z",
    transform: "translate(-2315.974 -1089.815)",
    fill: "#ffc675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9514",
    "data-name": "Path 9514",
    d: "M2377.8,1195.3c-.057,2.48-.45,7.158-1.637,9.11-2.072-2.2-7.791-5.706-13.992-14.676-8.724-12.62-11.244-25.622-9.259-40.037,2.017-14.649,9.705-13.981,1.511-17.653-6.522-2.926-13.088-12.336-15.957-15.976a43.78,43.78,0,0,1,2.62-5.688l11.233,2.6c7.742,4.6,16.607,10.411,16.607,10.411l3.594,20.806C2374.967,1163.316,2378.067,1183.609,2377.8,1195.3Z",
    transform: "translate(-2332.457 -1089.815)",
    fill: "#f2b255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9515",
    "data-name": "Path 9515",
    d: "M2443.125,1193.161s-7.651,6.484-21.646.32-21.994-43.782-15.844-53.88c2.093-3.437,3.94-6.725,5.4-9.562,2.826-5.5,4.194-9.295,3.085-9.176-1.677.184,28.206-16.3,28.206-16.3a33.152,33.152,0,0,1,2.5,5.931c2.242,6.966,3.932,18.892-5.219,29.306C2425.657,1155.663,2443.125,1193.161,2443.125,1193.161Z",
    transform: "translate(-2380.129 -1085.553)",
    fill: "#ffc675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9516",
    "data-name": "Path 9516",
    d: "M2465.368,1110.491s-13.478,21.169-33.785,19.549c2.823-5.5,4.192-9.295,3.083-9.176-1.677.184,28.205-16.3,28.205-16.3A33.172,33.172,0,0,1,2465.368,1110.491Z",
    transform: "translate(-2400.677 -1085.553)",
    fill: "#f2b255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9517",
    "data-name": "Path 9517",
    d: "M2389.738,1033.461s15.859,6.311,17.3,11.676-11.529,20.983-31.4,25.63-27.368-16.745-27.368-16.745,2.767-4.734,6.561-6.866C2359.68,1044.432,2364.332,1055.576,2389.738,1033.461Z",
    transform: "translate(-2339.637 -1033.461)",
    fill: "#ffc675"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4945",
    "data-name": "Group 4945",
    transform: "translate(36.787 215.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9518",
    "data-name": "Path 9518",
    d: "M2422.009,1498.387a9.742,9.742,0,0,0,4.262-10.577c-1.7-7.091-7.707-8.774-6.024-14.062a8.125,8.125,0,0,0,.841,9.885C2425.334,1488.812,2423.969,1495,2422.009,1498.387Z",
    transform: "translate(-2412.908 -1473.748)",
    fill: "#eaebf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9519",
    "data-name": "Path 9519",
    d: "M2398.261,1529.958a5.685,5.685,0,0,0,.806-7.772c-3.125-4.487-.806-6.276-.806-6.276s-3.281,2.272-1.278,5.356S2398.577,1528.2,2398.261,1529.958Z",
    transform: "translate(-2396.336 -1504.639)",
    fill: "#eaebf4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9520",
    "data-name": "Path 9520",
    d: "M2465.283,1523.718a5.685,5.685,0,0,1-.806-7.772c3.125-4.487.806-6.276.806-6.276s3.28,2.272,1.277,5.356S2464.967,1521.956,2465.283,1523.718Z",
    transform: "translate(-2445.376 -1500.067)",
    fill: "#eaebf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4961",
    "data-name": "Group 4961"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4959",
    "data-name": "Group 4959",
    transform: "translate(0.055 10.411)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9521",
    "data-name": "Path 9521",
    d: "M2316.969,726.056s-29.323-2.582-35.811,23.338-1.313,68.569,15.954,72.106,41.983-13.933,50.052-40.724S2342.069,726.909,2316.969,726.056Z",
    transform: "translate(-2273.241 -720.651)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4958",
    "data-name": "Group 4958"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4953",
    "data-name": "Group 4953"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9522",
    "data-name": "Path 9522",
    d: "M2292.182,718.677s7.835-2.684,8.84,7.471-7.686,21.031,8.776,26.078c0,0,3.773,2.011,3.979,8.906s1.456,7.487,5.7,9.451c0,0-.16,20.047,8.708,22.984,0,0-1.365-4.157-.725-7.321,0,0,2.57,1.892,7.312,1.661,0,0-3.395-3-4.054-4.845a14.672,14.672,0,0,0,11.632-.436s-5.4-4-4.919-13.582c0,0,.6-6.02,2.137-14.519s3.961-49.039-36.03-46.272c0,0-15.234-7.077-31.287,4.051s-13.1,37.305-13.1,37.305,1.6,1.749,4.978-.254c0,0-.073,2.869-2.1,4.023,0,0,13.117.132,16.359-10.442,0,0,3.8-2.523,3.807-9.677S2281.4,718.075,2292.182,718.677Z",
    transform: "translate(-2258.936 -706.034)",
    fill: "#212851"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4952",
    "data-name": "Group 4952",
    transform: "translate(4.494 2.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4949",
    "data-name": "Group 4949",
    transform: "translate(28.506 3.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4946",
    "data-name": "Group 4946",
    transform: "translate(0 0.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9523",
    "data-name": "Path 9523",
    d: "M2400.98,769.67a.7.7,0,0,0,.493-1.1c-2.523-3.458-1.542-6.242-.058-10.455a44.534,44.534,0,0,0,2.361-8.763,22.488,22.488,0,0,0-1.839-13.2,13.8,13.8,0,0,0-8.236-7.363c-7.079-2.1-11.132,4.971-11.177,5.051-.188.336-.239,1.035.1,1.224s.929-.206,1.118-.542c.059-.1,3.571-6.178,9.566-4.4,6.5,1.928,10.406,10.109,9.093,19.028a43.4,43.4,0,0,1-2.3,8.5c-1.513,4.3-2.709,7.688.247,11.739A.7.7,0,0,0,2400.98,769.67Z",
    transform: "translate(-2382.375 -728.392)",
    fill: "#121d3f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4947",
    "data-name": "Group 4947",
    transform: "translate(7.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9524",
    "data-name": "Path 9524",
    d: "M2437.338,779.044a.7.7,0,0,0,.42-1.189c-5.985-5.9-5.979-13.766-5.443-17.933.069-.534.148-1.1.231-1.694.907-6.486,2.278-16.287-4.31-23.976-7.923-9.246-17.918-6.481-18.018-6.452a.7.7,0,0,0-.475.863c.107.369.659.237,1.027.13s9.087-2.179,16.409,6.366c6.179,7.212,4.861,16.639,3.988,22.877-.084.6-.164,1.17-.233,1.709-.983,7.638,1.094,14.422,5.847,19.1A.7.7,0,0,0,2437.338,779.044Z",
    transform: "translate(-2409.715 -727.39)",
    fill: "#121d3f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4948",
    "data-name": "Group 4948",
    transform: "translate(13.152 0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9525",
    "data-name": "Path 9525",
    d: "M2463.986,785.423a.7.7,0,0,0,.34-1.257c-5.36-3.881-5.323-9.9-5.272-18.231a88.627,88.627,0,0,0-1.071-16.919c-2.153-11.967-9.047-17.192-14.452-19.468a26.676,26.676,0,0,0-11.314-2.075.7.7,0,0,0-.642.747c.029.383.354.341.737.313a29.942,29.942,0,0,1,10.729,2.32c7.369,3.124,11.936,9.318,13.571,18.409a87.436,87.436,0,0,1,1.049,16.664c-.052,8.418-.092,15.067,5.849,19.368A.692.692,0,0,0,2463.986,785.423Z",
    transform: "translate(-2431.573 -727.444)",
    fill: "#121d3f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4950",
    "data-name": "Group 4950",
    transform: "translate(13.022 7.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9526",
    "data-name": "Path 9526",
    d: "M2326.458,769.6a.7.7,0,0,0,.617-.575c.473-2.751,0-5.966-.506-9.369-.783-5.3-1.594-10.776,1.542-13.992,4.993-5.118,12.048-1.656,12.119-1.621a.7.7,0,1,0,.626-1.244c-.08-.04-8.044-3.948-13.742,1.893-3.618,3.709-2.757,9.534-1.924,15.168.487,3.29.947,6.4.511,8.93a.7.7,0,0,0,.755.811Z",
    transform: "translate(-2324.459 -741.479)",
    fill: "#121d3f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4951",
    "data-name": "Group 4951",
    transform: "translate(0 2.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9527",
    "data-name": "Path 9527",
    d: "M2276.513,762.944a.694.694,0,0,0,.362-.147c4.069-3.213,4.052-8.76,4.035-14.632-.02-6.767-.041-13.764,5.917-18.3,10.991-8.368,19.974-3.446,20.351-3.232a.7.7,0,0,0,.691-1.21,16.483,16.483,0,0,0-6.535-1.738c-3.623-.261-9.227.408-15.351,5.071-6.51,4.956-6.487,12.636-6.467,19.413.017,5.524.032,10.742-3.505,13.535a.7.7,0,0,0,.5,1.24Z",
    transform: "translate(-2275.747 -723.637)",
    fill: "#121d3f"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9528",
    "data-name": "Path 9528",
    d: "M2394.591,714.292c-2.52.348-8.815.827-11.3,10.434C2387.826,716.186,2393.581,715.062,2394.591,714.292Z",
    transform: "translate(-2354.542 -714.292)",
    fill: "#121d3f"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4957",
    "data-name": "Group 4957",
    transform: "translate(56.753 51.335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9529",
    "data-name": "Path 9529",
    d: "M2472.285,905.341s2.2-9.041,10.269-6.978-.4,22.455-7.238,20.748S2472.285,905.341,2472.285,905.341Z",
    transform: "translate(-2471.228 -898.057)",
    fill: "#f6af9a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4956",
    "data-name": "Group 4956",
    transform: "translate(4.168 5.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4954",
    "data-name": "Group 4954"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9530",
    "data-name": "Path 9530",
    d: "M2487.723,928.916a.714.714,0,0,0,.637-.788c-.834-7.328,3.068-9.094,3.235-9.165a.712.712,0,0,0-.546-1.314c-.207.085-5.065,2.186-4.1,10.64A.711.711,0,0,0,2487.723,928.916Z",
    transform: "translate(-2486.82 -917.595)",
    fill: "#e57e73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4955",
    "data-name": "Group 4955",
    transform: "translate(0.278 5.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9531",
    "data-name": "Path 9531",
    d: "M2488.641,939.855a.708.708,0,0,0,.442-.214,3.736,3.736,0,0,1,3.875-1.121.712.712,0,0,0,.5-1.331,5.136,5.136,0,0,0-5.4,1.464.711.711,0,0,0,.583,1.2Z",
    transform: "translate(-2487.859 -936.941)",
    fill: "#e57e73"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4960",
    "data-name": "Group 4960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9532",
    "data-name": "Path 9532",
    d: "M2342.552,737.19a46.2,46.2,0,0,1-3.184,6.74s-22.6-34.329-45.578-39.812S2261.472,707,2261.472,707s-1.655-34.834,46.9-39.641c18.855-1.866,29.575,6.143,34.917,17.853C2350.43,700.846,2347.989,723.072,2342.552,737.19Z",
    transform: "translate(-2260.734 -667.089)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9533",
    "data-name": "Path 9533",
    d: "M2454.932,786.857l-1.824-.513-38.258-37.82s23.039,12.308,34.609,5.261c8.648-5.269,7.395-14.554,6.21-18.906C2462.81,750.513,2460.369,772.739,2454.932,786.857Z",
    transform: "translate(-2373.114 -716.756)",
    fill: "#dc6565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9534",
    "data-name": "Path 9534",
    d: "M2269.566,778.2s-9.827,3.954-10.308,4.389-1.08-7.411.465-9.277c2.287-2.762,20.772-12.292,52.084,5S2342.2,812.1,2342.2,812.1s-.363,12.069-4.45,8.253-8.1-17.141-25.645-29.4S2283.385,775.117,2269.566,778.2Z",
    transform: "translate(-2258.729 -741.169)",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9535",
    "data-name": "Path 9535",
    d: "M2350.712,727.517s-6.867-2.527-22.454-3.889c0,0,2.11-7.074,4.567-10.006.882-1.052,20.048,1.534,22.332,3.126C2355.157,716.748,2352.1,724.446,2350.712,727.517Z",
    transform: "translate(-2309.671 -701.003)",
    fill: "#ffc675",
    opacity: 0.65
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4986",
    "data-name": "Group 4986",
    transform: "translate(1782.882 946.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4967",
    "data-name": "Group 4967",
    transform: "translate(0 86.822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4966",
    "data-name": "Group 4966",
    transform: "translate(3.138)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9536",
    "data-name": "Path 9536",
    d: "M2755.649,2608.646s0,6.916-2.305,11.526-3.17,17.866,5.187,25.357l-12.679-.576s-3.17-8.933-2.882-17.578,4.322-12.967,4.322-21.323Z",
    transform: "translate(-2733.974 -2454.236)",
    fill: "#c95959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9537",
    "data-name": "Path 9537",
    d: "M2815,2315.146s-13.832-1.152-20.459.864l-.865-7.492s12.391-2.593,21.612-1.153Z",
    transform: "translate(-2771.142 -2235.08)",
    fill: "#c95959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9538",
    "data-name": "Path 9538",
    d: "M2754.386,2040.718s-24.781-6.916-34.29,2.017-12.1,33.138-10.085,55.038,5.475,40.341,6.051,65.7,1.441,34.578,15.272,33.426c3.746-.288,5.475-6.34,5.763-25.934s-.865-45.528-2.017-64.258-1.153-45.817,2.593-47.257,10.662.576,14.12,3.746Z",
    transform: "translate(-2709.371 -2038.165)",
    fill: "#2f4066"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9539",
    "data-name": "Path 9539",
    d: "M2742.041,2740.243s-12.391.576-21.035-2.881-20.171-1.729-22.476,7.78-5.408,33.7,64.292,45.522Z",
    transform: "translate(-2697.634 -2549.237)",
    fill: "#d35f5f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4985",
    "data-name": "Group 4985",
    transform: "translate(42.026)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9540",
    "data-name": "Path 9540",
    d: "M2993.9,1739.988a17.577,17.577,0,0,0-3.321-4.718c-3.681-3.738-12.031-11.465-21.44-15.171-12.677-4.994-23.818-8.452-41.106-5.763s-49.942,5.763-57.625,10.373-13.446,16.135-14.214,32.27,1.152,79.907,1.536,117.171-1.152,103.725-1.152,125.622,9.6,39.185,22.282,41.874,81.827-.768,117.555-10.757c5.763-2.3,15.367-9.22,16.9-25.355s-3.458-92.584-4.61-116.4-4.994-80.675-7.684-107.951C2998.565,1756.18,2998.36,1749.253,2993.9,1739.988Z",
    transform: "translate(-2855.704 -1713.398)",
    fill: "#ffc675"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4984",
    "data-name": "Group 4984"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4969",
    "data-name": "Group 4969",
    transform: "translate(0.316 13.192)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9541",
    "data-name": "Path 9541",
    d: "M2878.865,2077.8c-12.678-2.689-22.282-19.976-22.282-41.874s1.537-88.358,1.152-125.622-2.3-101.036-1.536-117.171c.679-14.262,5.261-24.922,11.622-30.388,4.451.14,13.876,1.208,25.642,6.954,16.519,8.068,21.9,14.214,23.435,18.056s.384,55.32,1.536,83.748.384,95.273,0,123.317c-.347,25.362,5.589,69.888,1.045,83C2900.255,2078.977,2884.324,2078.959,2878.865,2077.8Z",
    transform: "translate(-2856.02 -1762.745)",
    fill: "#f2b255"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4968",
    "data-name": "Group 4968",
    transform: "translate(0.559 83.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9542",
    "data-name": "Path 9542",
    d: "M2858.111,2074.341s19.371,35.24,62.306,57.14l.138,4.128c.119,30.819-.325,68.281-.589,87.507-.348,25.361,5.588,69.887,1.044,83-19.224,1.152-35.155,1.134-40.614-.024-12.677-2.689-22.281-19.977-22.281-41.874s1.536-88.358,1.152-125.622C2859.083,2120.583,2858.538,2096.37,2858.111,2074.341Z",
    transform: "translate(-2858.111 -2074.341)",
    fill: "#f2b255"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9543",
    "data-name": "Path 9543",
    d: "M2858.129,2265.225c0-21.9,1.537-88.358,1.152-125.623-.185-17.917-.724-41.96-1.15-63.892l.443.415c2.774,4.7,18.462,29.662,49.282,49.187-1,14.266-6.782,79.22-32.955,156.724a72.444,72.444,0,0,1-14.882-.6A68.019,68.019,0,0,1,2858.129,2265.225Z",
    transform: "translate(-2858.124 -2075.345)",
    fill: "#ffc675"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4971",
    "data-name": "Group 4971",
    transform: "translate(0.457 240.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9544",
    "data-name": "Path 9544",
    d: "M2863.556,2713.3c41.931,3.012,49.629-26.629,52.206-35.5,1.387-4.779,5.538-8.187,8.312-10,.809,25.724,4.925,61.586.927,73.128-19.224,1.152-35.155,1.134-40.614-.024C2874.63,2738.827,2864.207,2728.97,2863.556,2713.3Z",
    transform: "translate(-2861.682 -2652.978)",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4970",
    "data-name": "Group 4970"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9545",
    "data-name": "Path 9545",
    d: "M2918.938,2627.191s-29.206,27.448-61.959,27.867a43.386,43.386,0,0,1,.127-12.982c1.807-.447,35.779-9.052,61.78-29.7-.023,1.753-.045,3.4-.066,4.938-.042,3.045.007,6.366.118,9.876Z",
    transform: "translate(-2856.546 -2612.377)",
    fill: "#c95959"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9546",
    "data-name": "Path 9546",
    d: "M2924.906,2665.912a3.47,3.47,0,0,1,3.371-.038,3.886,3.886,0,0,1,1.818,2.431c.7,2.361,4.9,12.967,2.882,14.7s-19.883,8.933-22.764,8.933-6.916-14.7-6.627-16.137,9.221-4.034,12.679-5.475C2918.92,2669.215,2923.109,2666.917,2924.906,2665.912Z",
    transform: "translate(-2890.998 -2651.266)",
    fill: "#223859"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4983",
    "data-name": "Group 4983"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4976",
    "data-name": "Group 4976",
    transform: "translate(49.092 84.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4973",
    "data-name": "Group 4973",
    transform: "translate(0 20.468)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9547",
    "data-name": "Path 9547",
    d: "M3075.694,2108.55s1.605,66.635,2.827,79.255c1.387,14.335,1.266,22.145,2.13,26.467,0,0-8.593,2.39-12.627,1.238,0,0-1.7-96.424-1.986-107.95Z",
    transform: "translate(-3058.669 -2107.559)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4972",
    "data-name": "Group 4972",
    transform: "translate(0 16.028)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 23.05,
    height: 39.185,
    rx: 11.525,
    transform: "translate(24.972 39.136) rotate(177.147)",
    fill: "#3b4a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9548",
    "data-name": "Path 9548",
    d: "M3108.623,2214.007l.771,15.471a7.779,7.779,0,0,1-.771-15.471Z",
    transform: "translate(-3084.982 -2201.578)",
    fill: "#283c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9549",
    "data-name": "Path 9549",
    d: "M3048.16,2224.746a7.781,7.781,0,0,1-6.665,7.7l-.771-15.471A7.779,7.779,0,0,1,3048.16,2224.746Z",
    transform: "translate(-3040.122 -2203.751)",
    fill: "#283c60"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4975",
    "data-name": "Group 4975",
    transform: "translate(93.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9550",
    "data-name": "Path 9550",
    d: "M3395.282,2033.731s10.327,79.825,11.48,91.063,3.17,25.646,5.763,33.138a56.5,56.5,0,0,1-10.374.576s-8.689-104.747-10.418-127.511Z",
    transform: "translate(-3390.573 -2030.997)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4974",
    "data-name": "Group 4974",
    transform: "translate(0 34.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9551",
    "data-name": "Path 9551",
    d: "M3394.073,2201.431l8.314-.6a4.284,4.284,0,0,0,3.966-4.58l-2.091-30.989a4.284,4.284,0,0,0-4.58-3.966l-8.314.6a4.283,4.283,0,0,0-3.966,4.58l2.09,30.989A4.284,4.284,0,0,0,3394.073,2201.431Z",
    transform: "translate(-3387.392 -2161.288)",
    fill: "#3b4a75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9552",
    "data-name": "Path 9552",
    d: "M3442.956,2211.735l.921,13.656a7.778,7.778,0,0,1-.921-13.656Z",
    transform: "translate(-3425.443 -2198.249)",
    fill: "#283c60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9553",
    "data-name": "Path 9553",
    d: "M3394.421,2223.368a7.774,7.774,0,0,1-3.663,6.6l-.924-13.695A7.78,7.78,0,0,1,3394.421,2223.368Z",
    transform: "translate(-3389.181 -2201.574)",
    fill: "#283c60"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4982",
    "data-name": "Group 4982"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4979",
    "data-name": "Group 4979",
    transform: "translate(57.736 20.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4977",
    "data-name": "Group 4977",
    transform: "translate(21.129 55.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9554",
    "data-name": "Path 9554",
    d: "M3340.967,1998.562s1.153,126.775,11.909,170.57l8.452-1.537s-11.909-46.484-12.678-167.881Z",
    transform: "translate(-3289.873 -1998.562)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9555",
    "data-name": "Path 9555",
    d: "M3157.527,2020.117s9.988,114.866,3.073,174.028h-8.067s6.531-101.8-2.689-172.107Z",
    transform: "translate(-3149.843 -2014.354)",
    fill: "#e56c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4978",
    "data-name": "Group 4978",
    transform: "translate(3.832 220.634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9556",
    "data-name": "Path 9556",
    d: "M3153.148,2618.335s22.281-3.458,26.892-1.153,6.147,19.977,6.147,36.112-.384,31.5-16.9,36.112-75.681,10.757-79.138,9.22-4.61-13.83-4.226-31.885-4.994-39.569,8.067-42.258S3153.148,2618.335,3153.148,2618.335Z",
    transform: "translate(-3085.141 -2616.39)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9557",
    "data-name": "Path 9557",
    d: "M3167.488,2636.389s19.64-3.047,23.7-1.016,5.418,17.609,5.418,31.831-.339,27.768-14.9,31.832-66.711,9.482-69.758,8.127-4.064-12.191-3.725-28.106-4.4-34.879,7.111-37.249S3167.488,2636.389,3167.488,2636.389Z",
    transform: "translate(-3101.553 -2629.786)",
    fill: "#ffc675"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9558",
    "data-name": "Path 9558",
    d: "M3377.636,2630.04c3.184-.872,6.23-.757,7.485-.129,1.454.727,2.545,6.281,3.367,9.793,1.338,11.4,1.949,32.362-2.806,51.12-1.435,4.131-4.58,4.58-9.248,5.6C3379.213,2684.216,3383.335,2655.74,3377.636,2630.04Z",
    transform: "translate(-3298.562 -2625.931)",
    fill: "#e56c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9559",
    "data-name": "Path 9559",
    d: "M3160.86,2652.361c4.134-1.648,7.2-1.772,9.957-1.132,1.683,8.424,7.461,42.166-2.246,66.889a19.418,19.418,0,0,1-10.556.854C3161.988,2706.309,3167.512,2681.107,3160.86,2652.361Z",
    transform: "translate(-3138.533 -2641.653)",
    fill: "#e56c6c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_9560",
    "data-name": "Path 9560",
    d: "M3074.265,1808.518a15.813,15.813,0,0,0-3.327-4.851l-.131-3.6s48.916-10.942,76.352-8.672c.283.28.548.546.793.793a17.6,17.6,0,0,1,3.32,4.718c4.455,9.265,4.66,16.192,7.126,41.193.6,6.057,1.251,13.573,1.92,21.861-3.135-3.8-13.034-13.1-34.19-11.873-24.862,1.441-41.951,20.119-50.634,33.843C3074.873,1852.89,3075.629,1811.929,3074.265,1808.518Z",
    transform: "translate(-3070.807 -1791.085)",
    fill: "#e56c6c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4981",
    "data-name": "Group 4981"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9561",
    "data-name": "Path 9561",
    d: "M2898.913,1724.709c7.684-4.61,40.338-7.684,57.625-10.373s28.428.768,41.105,5.763c9.409,3.706,17.759,11.433,21.44,15.171a17.6,17.6,0,0,1,2.88,3.865c-12.184-1.4-49.1-3.828-78.487,13.234l-48.558-24.459A19.9,19.9,0,0,1,2898.913,1724.709Z",
    transform: "translate(-2884.203 -1713.398)",
    fill: "#f79494"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9562",
    "data-name": "Path 9562",
    d: "M2866.955,1762.745c4.451.14,13.876,1.208,25.642,6.954,16.519,8.068,21.9,14.214,23.434,18.056,1.359,3.4.614,44.063,1.222,73.083-2.747-2.484-23.463-19.814-61.541-14.792a520.777,520.777,0,0,1-.379-52.913C2856.012,1778.871,2860.594,1768.211,2866.955,1762.745Z",
    transform: "translate(-2854.837 -1749.553)",
    fill: "#d35f5f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4980",
    "data-name": "Group 4980",
    transform: "translate(9.605 85.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9563",
    "data-name": "Path 9563",
    d: "M2935.439,2040.114a.5.5,0,0,1-.188-.038c-.259-.107-26.177-10.633-43.859-5.743a.5.5,0,1,1-.264-.954c18.012-4.983,44.237,5.674,44.5,5.782a.5.5,0,0,1-.188.953Z",
    transform: "translate(-2890.765 -2032.053)",
    fill: "#c95959"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutImage1);
export default __webpack_public_path__ + "static/media/about-image-1.8f33220aaf44cf0071b8f0c7901e7ec0.svg";
export { ForwardRef as ReactComponent };